import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import './css/index.css';
import AppContainer from './containers/app';
import ErrorMsgContainer from './containers/error-msg';

import rootReducers from './reducers';
import preloadedState from './state';
import persiste from './middlewares/persiste';
import Rotas from './routes';
 

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let middlewares = [thunk, persiste];

if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

var state = false;// window.sessionStorage['__state-solicitacao-viagem'];
if (state) {
    state = JSON.parse(state);
} else {
    state = preloadedState;
}

const store = createStore(rootReducers, state,
    composeEnhancers(
        applyMiddleware(...middlewares)
    )
);




ReactDOM.render(
    <Provider store={store}>
        <AppContainer>
            <Rotas />
            <ErrorMsgContainer />
        </AppContainer>
    </Provider>, document.getElementById('root-react-app'));